import { render, staticRenderFns } from "./MaterialIcon.vue?vue&type=template&id=834953b0&"
import script from "./MaterialIcon.vue?vue&type=script&lang=ts&"
export * from "./MaterialIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports